import DefaultAttr from './default'
export default class Report extends DefaultAttr {
  reportParams = {
    //  辅助表id
    auxiliaryTableId: '',
    //  定时
    timing: ''
  }
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
    // 挂载背景颜色
    this.setStyleSetting(args.type, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/report.js